// extracted by mini-css-extract-plugin
export default {"container":"FormNormal_container__35XTb","form":"FormNormal_form__v7p-f","swal-custom-popup":"FormNormal_swal-custom-popup__tFUYc","button":"FormNormal_button__zmU4w"};